import { useEffect, useState } from "react"
import { Col, Row, Card, CardBody, TabContent, TabPane } from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import ThemeTabs from "pages/StockPages/StockView/ThemeTabs"
import VehicleMovementList from "../VehicleMovementList/VehicleMovementList"
import { useListParams } from "hooks/useListParams"
import MovementKeyContainer from "../MovementKeyList/MovementKeyContainer"
import DailyVehicleAuditContainer from "../DailyVehicleAudit/DailyVehicleAuditContainer"

const MovementContainer = () => {
  // URL search params hook
  const { params, updateParams, resetParams } = useListParams({
    tab: "movement-list",
  })

  // NavTab
  const [activeTab, setActiveTab] = useState(params?.tab || "movement-list")
  const toggleTab = tab => {
    resetParams()
    updateParams({ tab })
    if (activeTab !== tab) setActiveTab(tab)
  }

  // Toggle Tab
  useEffect(() => {
    if (params?.tab) {
      toggleTab(params?.tab)
    }
  }, [params?.tab])

  const tabsData = [
    {
      id: "movement-list",
      label: "Vehicle Movement List",
      icon: "bx bx-car",
    },
    { id: "key-list", label: "Key List", icon: "bx bx-key" },
    {
      id: "daily-audit",
      label: "Daily Vehicle Audit",
      icon: "bx bx-check-shield",
    },
  ]

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs
          title="Vehicle Movement"
          breadcrumbItem="Vehicle Movement List"
        />
        <Row>
          <Col lg="12">
            <Card>
              <CardBody>
                <ThemeTabs
                  activeTab={activeTab}
                  toggleTab={toggleTab}
                  loading={false}
                  tabsData={tabsData}
                />

                <TabContent activeTab={activeTab}>
                  {/* Movement List Tab */}
                  <TabPane tabId="movement-list">
                    <VehicleMovementList />
                  </TabPane>

                  {/* Key List Tab */}
                  <TabPane tabId="key-list">
                    <MovementKeyContainer />
                  </TabPane>

                  {/* Daily Vehicle Audit Tab */}
                  <TabPane tabId="daily-audit">
                    <DailyVehicleAuditContainer />
                  </TabPane>
                </TabContent>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default MovementContainer
